import { Box, Breadcrumbs, Typography } from '@mui/material';

import { FlexBox, TitleBox } from '../../../components/Sections/Title/styles';
import { OSNumber, StyledContainer } from '../styles';

interface CharacteristicsTitleProps {
  osNumber?: number;
  pageTitle: string;
}

export function CharacteristicsTitle({
  osNumber,
  pageTitle,
}: CharacteristicsTitleProps): JSX.Element {
  return (
    <StyledContainer>
      <TitleBox>
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={{ '& .MuiBreadcrumbs-separator': { fontSize: '28px' } }}
        >
          <Typography color="primary.dark" fontSize="24px">
            {pageTitle}
          </Typography>
          <Typography color="primary.dark" fontSize="24px" fontWeight="600">
            Características
          </Typography>
        </Breadcrumbs>
        <FlexBox alignItems="center">
          {!!osNumber && (
            <OSNumber sx={{ height: '32px' }}>OS {osNumber}</OSNumber>
          )}
          <Box
            sx={{
              width: '210px',
              borderRadius: '10px',
              border: '1.5px solid',
              borderColor: 'primary.dark',
              color: 'primary.dark',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '36px',
              fontSize: '14px',
            }}
          >
            modo leitura
          </Box>
        </FlexBox>
      </TitleBox>
    </StyledContainer>
  );
}
